import { useContext } from "react";
import { NotificacoesContext } from "shared/contexts/Auth/Notificacoes/NotificacoesContext";

export function useNotificacoes() {
  return useContext(NotificacoesContext);
}